/* eslint-disable */

const _ = require('lodash');
const changeCase = require('change-case');

const backgroundColorMap = {
	'#c9d2fc': 'light-purple',
	'#A2D8C0': 'teal',
	'#F2CC7B': 'yellow',
	'#FC7E7E': 'red',
	'#D7EDAF': 'green',
	'#A5C6EF': 'blue',
	'#C8B8F2': 'purple',
	'#bad5dd': 'light-blue'
};

const catColorMap = {
	'#FCB47E': 'orange',
	'#5E5E5E': 'black',
	'#B3B3B3': 'gray',
	'#FCDAC9': 'white',
};

let getOld = {
	_id: function(cat) {
		return cat._id;
	},
	name: function(cat) {
		return cat.name;
	},
	body: function(cat) {
		return cat.body;
	},
	head: function(cat) {
		return cat.head;
	},
	color: function(cat) {
		return cat.color.cat;
	},
	bgColor: function(cat) {
		return cat.color.background;
	},
	likesPets: function(cat) {
		return cat.likesPets;
	},
	kitten: function(cat) {
		return cat.kitty;
	},
	glasses: function(cat) {
		return _.get(cat, ['activeGoodies', 'glasses'], null);
	},
	hat: function(cat) {
		return _.get(cat, ['activeGoodies', 'hat'], null);
	},
	toy: function(cat) {
		return _.get(cat, ['activeGoodies', 'toy'], null);
	}
};

let makeNew = {
	_id: function(id) {
		// id is the same
		return id;
	},
	name: function(oldName) {
		// name is the same
		return oldName;
	},
	body: function(oldBody) {
		// old body is a string
		// new body is a number
		return Number(oldBody);
	},
	head: function(oldHead) {
		// old head was a string
		// new head is a number
		return Number(oldHead);
	},
	color: function(oldColor) {
		// old color was the classname for cat color, 'cat-[color]',
		// new color is just the string of cat color, without class prefix, '[color]'.
		// If it was an old hex code, convert it using the table above.
		if (oldColor.indexOf('#') === 0) return (catColorMap[oldColor] || 'orange');
		return oldColor.replace('cat-', '').replace('grey', 'gray');
	},
	bgColor: function(oldBgColor) {
		// old bgColor was the classname for bg color, 'bg-[color]',
		// new bgColor is just the string of bg color, without class prefix, '[color]'.
		// If it was an old hex code, convert it using the table above.
		if (oldBgColor.indexOf('#') === 0) return (backgroundColorMap[oldBgColor] || 'light-purple');
		return oldBgColor.replace('bg-','');
	},
	likesPets: function(oldLikesPets) {
		// old likesPets was Boolean, but is sometimes interpreted as string
		// new is string for class.
		if (typeof oldLikesPets === 'boolean') {
			return oldLikesPets ? 'likes' : 'hates';
		} else {
			return oldLikesPets === 'true' ? 'likes' : 'hates';
		}
	},
	kitten: function(oldKitten) {
		// old kitten was kitty id (lowercase) or 'no-kitty'.
		// new kitten is kitty id (capitalized) or the prop doesn't exist.
		let hasKitten = !_.isUndefined(oldKitten) && oldKitten !== 'no-kitty';

		if (!hasKitten) {
			return undefined;
		} else {
			// given 'poop-kitten' should return 'PoopKitten'.
			return changeCase.pascalCase(oldKitten);
		}
	},
	glasses: function(oldGlasses) {
		// old goodies were 'goodytype-n'
		// new goodies are 'GoodyName';
		let newGlasses;
		let glassesMap = {
			"glasses-1": "glasses-Raybans",
			"glasses-2": "glasses-CatEye",
			"glasses-3": "glasses-ThreeD",
			"glasses-4": "glasses-OldMan",
			"glasses-5": "glasses-Scuba",
			"glasses-6": "glasses-Kerry",
			"glasses-7": "glasses-Blue",
			"glasses-8": "glasses-Sunglasses"
		};

		if (!_.isUndefined(oldGlasses)) {
			newGlasses = glassesMap[oldGlasses];
		}

		return newGlasses || null;
	},
	hat: function(oldHat) {
		// old goodies were 'goodytype-n'
		// new goodies are 'GoodyName';
		let newHat;
		let hatMap = {
			"hat-1": "hat-PartyHat",
			"hat-2": "hat-Fedora",
			"hat-3": "hat-Fez",
			"hat-4": "hat-Chef",
			"hat-5": "hat-Baseball",
			"hat-6": "hat-Beanie",
			"hat-7": "hat-Princess",
			"hat-8": "hat-King",
			"hat-9": "hat-Unicorn",
			"hat-10": "hat-Sweatband",
			"hat-11": "hat-Spinner",
			"hat-12": "hat-Bow"
		};

		if (!_.isUndefined(oldHat)) {
			newHat = hatMap[oldHat];
		}

		return newHat || null;
	},
	toy: function(oldToy) {
		// old goodies were 'goodytype-n'
		// new goodies are 'GoodyName';
		let newToy;
		let toyMap = {
			"toy-1": "toy-Yarn",
			"toy-2": "toy-Mouse",
			"toy-3": "toy-Pizza",
			"toy-4": "toy-Fishbones",
			"toy-5": "toy-SoccerBall",
			"toy-6": "toy-Donut",
			"toy-7": "toy-Fishbowl",
			"toy-8": "toy-Campfire",
			"toy-9": "toy-MagicWand",
			"toy-10": "toy-IceCream",
			"toy-11": "toy-Coffee",
			"toy-12": "toy-MiniGolf",
			"toy-13": "toy-Flamingo",
			"toy-14": "toy-Rocketship",
			"toy-15": "toy-FoamFinger",
			"toy-16": "toy-BonsaiTree",
			"toy-17": "toy-Wine",
			"toy-18": "toy-Synth",
			"toy-19": "toy-Martini"
		};

		if (!_.isUndefined(oldToy)) {
			newToy = toyMap[oldToy];
		}

		return newToy || null;
	}
};

function translateLegacyCat(cat) {
	let newCat = {};

	if (cat.petType) {
		// This is a new cat with a petType defined.
		return cat;
	}

	if (!cat) {
		console.error('Your cat was undefined.');
		return newCat;
	}

	_.forOwn(getOld, function(value, key) {
		newCat[key] = makeNew[key](value(cat));
	});

	return newCat;
}

module.exports = {
	makeNew: makeNew,
	getOld: getOld,
	translateLegacyCat: translateLegacyCat
};



// WEBPACK FOOTER //
// ./src/utils/translateLegacyCat.js